<template>
  <input
    ref="input"
    v-model="modelValue"
    :class="[
      plainText ? 'form-control-plaintext' : 'form-control',
      props.size && `form-control-${props.size}`,
      props.class,
    ]"
  >
</template>

<script setup>
import { ref } from 'vue'
import { useVModel } from '@vueuse/core'
import { SIZES } from '@shared/constants/bootstrap'

/* eslint-disable vue/require-default-prop */
const props = defineProps({
  defaultValue: { type: [String, Number], required: false },
  modelValue: { type: [String, Number], required: false },
  plainText: { type: Boolean, required: false, default: false },
  class: { type: null, required: false },
  size: {
    type: null,
    required: false,
    validator: (val) => SIZES.includes(val),
  },
})

const emits = defineEmits(['update:modelValue'])

const modelValue = useVModel(props, 'modelValue', emits, {
  passive: true,
  defaultValue: props.defaultValue,
})

const input = ref(null)

defineExpose({ input })
</script>
